import React from 'react';
import { View, Image } from 'react-native';
import { Icon } from 'react-native-elements';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { PlayerTagProps } from "../../../store/types/soc_svc"

type PlayerTagLozengeProps = {
    player_tag: PlayerTagProps,
    editable?:boolean,
    selected?:boolean,
    onRemove?: (player_tag:PlayerTagProps) => void,
    onSelect?: (player_tag:PlayerTagProps) => void,
}

const PlayerTagLozenge = ({ player_tag, editable, selected, onRemove, onSelect }:PlayerTagLozengeProps) => {

    const handleSelect = () => {
        if(editable && onRemove){ return onRemove(player_tag) }
        if(!editable && onSelect){ return onSelect(player_tag) }
    }

    return (
        <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', padding:10, marginTop:2, marginBottom:2, borderRadius: 18, backgroundColor: selected?Colors.highlights.highlight200:Colors.shades.white, shadowColor: "rgba(0, 41, 120, 0.12)", shadowOffset: { width: 0, height: 2 }, shadowRadius: 4, shadowOpacity: 1 }} onPress={() => handleSelect()}>
            {player_tag.tag_type === 'company'?
                <Image style={{height:16, width:16, borderRadius:100}} source={player_tag.companyDetails?{ uri: player_tag.companyDetails?.profile_pic }:require('../../../assets/images/default-avatar.png')} />
            :<></>}
            <Text size={12} weight='bold' textAlign='center' color={selected?Colors.shades.white:Colors.brand.midnight}>{player_tag.tag}</Text>
            {editable?
            <View>
                <Icon containerStyle={{marginLeft:12}} name='x' type='feather' color={Colors.brand.slate} size={16} />
            </View>
            :
            <></>}
        </TouchableOpacity>
    )
}

export default PlayerTagLozenge